<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <v-textarea
        v-model="localValue"
        outlined
        rows="3"
        :error-messages="errorMessage"
        :error="!!errorMessage"
      />
    </v-card-text>
    <v-card-actions>
      <v-select
        v-if="showColorPicker"
        v-model="color"
        :items="colorsList"
        return-object
        label="Color"
        dense
        outlined
        hide-details
      >
        <template v-slot:selection="{ item }">
          <v-list-item-avatar style="margin: 0px">
            <v-icon :color="item">mdi-circle</v-icon>
          </v-list-item-avatar>
        </template>
        <template v-slot:item="{ item }">
          <v-list-item-avatar style="margin: 0px" :key="item">
            <v-icon :color="item">mdi-circle</v-icon>
          </v-list-item-avatar>
        </template>
      </v-select>
      <v-spacer></v-spacer>
      <v-btn
        rounded
        outlined
        color="primary"
        @click="handleCancelClick"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <SubmitButton
        :label="submitLabel || $t('common.save')"
        @click="handleSaveClick"
      />
    </v-card-actions>

  </v-card>
</template>

<script>
export default {
  name: 'VariationCommentForm',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    submitLabel: {
      type: String,
      default: ''
    },
    showColorPicker: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue: this.value,
      color: 'secondary',
      errorMessage: null
    }
  },
  computed: {
    colorsList () {
      return ['secondary', 'blue', 'red', 'success', 'purple']
    }
  },
  methods: {
    handleCancelClick () {
      this.localValue = ''
      this.color = 'secondary'
      this.errorMessage = null
      this.$eventBus.$emit('CLOSE_MODAL')
    },
    handleSaveClick () {
      const trimmedValue = this.localValue ? this.localValue.trim() : ''
      if (trimmedValue) {
        if (this.showColorPicker) {
          this.$emit('input', { comment: trimmedValue, color: this.color })
          this.color = 'secondary'
        } else {
          this.$emit('input', trimmedValue)
        }
        this.localValue = ''
        this.errorMessage = null
      } else {
        this.errorMessage = this.$t('variation.commentError')
      }
    }
  },
  watch: {
    value (newValue) {
      this.localValue = newValue
      this.errorMessage = null
    }
  }
}
</script>
